import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { useFormErrorMessageHandler } from '@/utils/form';
import { clearAuthTokens } from 'axios-jwt';
import { ref, reactive, computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { required, sameAs } from '@vuelidate/validators';
import { ElNotification } from 'element-plus';

import { passwordRegex as passwordRule } from '@/utils/vuelidate-custom';
import { useForm } from '@/core/hooks/forms';
import { useFormUpdate } from '@/hooks/forms';
import {
  useGetCurrentUserQuery,
  useGetUserQuery,
  useUpdateUserPasswordMutation,
} from '@/entities/user/hooks';

import { UpdateUserPasswordData } from '@/entities/user/types';

import {
  NkForm,
  NkGroup,
  NkStack,
  NkFormItem,
  NkInputText,
  NkButton,
  NkPasswordError,
} from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserUpdatePasswordForm',
  emits: [],
  setup(__props, { emit }) {


const { onSubmitted } = useForm(emit);

// const handleValidationChange = (value) => {
//   console.log(value);
// };

const { t } = useI18n();
const router = useRouter();

const { data: currentUserData } = useGetCurrentUserQuery();

const queryData = computed(() => ({
  id: currentUserData?.value?.id,
}));

const form = ref();

const fields = reactive({
  oldPassword: '',
  newPassword: '',
  newPasswordConfirmation: '',
} as UpdateUserPasswordData);

const { newPassword } = toRefs(fields);

const rules = computed(() =>
  ({
    oldPassword: {
      required,
    },
    newPassword: {
      required,
      passwordRule,
    },
    newPasswordConfirmation: {
      required,
      sameAs: sameAs(newPassword),
    },
  }),
);

const {
  mutation: {
    mutateAsync,
    isError,
    isLoading: isUpdateLoading,
    error: updateError,
  },
} = useFormUpdate({
  fields,
  queryData,
  mutationHook: useUpdateUserPasswordMutation,
  queryHook: useGetUserQuery,
});

const { error } = useFormErrorMessageHandler(updateError);

const submit = () => {
  form.value.validator.$validate().then((valid: boolean) => {
    if (valid && !isUpdateLoading.value) {
      mutateAsync(
        fields,
        {
          onSuccess: () => ElNotification({
            title: t('user.notification.password.update.title'),
            message: t('user.notification.password.update.message'),
            type: 'success',
            position: 'bottom-right',
          }),
        },
      ).then((d) => {
        onSubmitted(d);
        clearAuthTokens();
        router.push('/login');
      });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(NkForm), {
    ref_key: "form",
    ref: form,
    fields: fields,
    rules: _unref(rules)
  }, {
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 0,
            type: "error",
            title: _unref(error)
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NkStack), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NkFormItem), {
            prop: "oldPassword",
            label: _ctx.$t('profile.form.password.label')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkInputText), {
                type: "password",
                modelValue: fields.oldPassword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.oldPassword) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(NkFormItem), {
            prop: "newPassword",
            label: _ctx.$t('profile.form.new_password.label')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkInputText), {
                type: "password",
                modelValue: fields.newPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fields.newPassword) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(NkPasswordError), {
            password: fields.newPassword
          }, null, 8, ["password"]),
          _createVNode(_unref(NkFormItem), {
            prop: "newPasswordConfirmation",
            label: _ctx.$t('profile.form.confirm_new_password.label')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkInputText), {
                type: "password",
                modelValue: fields.newPasswordConfirmation,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fields.newPasswordConfirmation) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(NkGroup), { position: "right" }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(NkButton), { onClick: submit }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('actions.update')), 1)
                ]),
                _: 1
              })), [
                [_directive_loading, _unref(isUpdateLoading)]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["fields", "rules"]))
}
}

})